import React from "react";
import "./story.scss";

const Story = () => {
  return (
    <div className="containerStory">
      <span></span>
      <h1 className="storyHeading fade-in">Our Story</h1>
      <span></span>
      <div className="contentStory fade-in">
        <br></br>
        <br></br>
        <p>
          We think of ourselves as hands-on curator. For us make is integral to
          our design philosophy. It is crucial how a piece of clothing feels
          when worn. We’ve always wanted clothes to be the way we drew them –
          relaxed and lived in, a natural look. We find men’s clothes
          interesting in their structure, feel and functionality. We started by
          designing men’s clothes, and then found that women wanted them.
          <br />
          <br />
          We're inspired by the authenticity we can find in nature, people and
          places, and we think it is the same quality we look for in the
          materials we choose. For example, the feel of hand-woven Harris tweed
          and the irregular slub of Irish linen. We feel passionate about
          landscape, and its connection with such fabrics and the skilled people
          who weave them.
          <br />
          <br />
          We like to work with manufacturers who understand and share this
          passion for make and quality of fabric: specialists such as John
          Smedley in fine-gauge knitwear, Mackintosh and their part hand-made
          raincoats, and the Scottish knitting factories that continue their
          heritage of producing the best cashmere in the world.
          <br />
          <br />
          We also find these qualities in other people’s work. In 1970, We was
          encouraged by finding – at a jumble sale – an old, yet finely stitched
          pinstripe shirt. Today we still find it exciting to hunt out objects
          we consider to be well-made and enduring. In particular, mid-20th
          century products such as Anglepoise lamps, Ercol furniture, and Robert
          Welch stainless steel cutlery, represent the best of our heritage of
          timeless functional design. We enjoy pulling these threads of
          tradition, quality and skill together in clothes that are meant to be
          worn in the real world, where good design is about living with
          thoughtful style.
        </p>
      </div>
      <span></span>
    </div>
  );
};

export default Story;
